import { render, staticRenderFns } from "./iconArrowRight.vue?vue&type=template&id=23fcbf56&"
import script from "./iconArrowRight.js?vue&type=script&lang=js&"
export * from "./iconArrowRight.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports